module.exports = __webpack_public_path__ + "static/educate-magis-es-87309a1bb1ec94ff7f24f4ed452c8f52.svg";